import * as React from 'react'

const useConnectivity = () => {
  const [connected, setConnected] = React.useState(navigator.onLine)

  const onOnline = () => setConnected(true)
  const onOffline = () => setConnected(false)

  React.useEffect(() => {
    window.addEventListener('online', onOnline)
    window.addEventListener('offline', onOffline)

    return () => {
      window.removeEventListener('online', onOnline)
      window.removeEventListener('offline', onOffline)
    }
  }, [])

  return [connected, false] as const
}

export default useConnectivity
